var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "detail" } },
    [
      _vm._m(0),
      _vm._v(" "),
      _c("UpdateHolidayPlusChannel", { attrs: { channel: _vm.clone } }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "header" }, [
      _c("div", { staticClass: "title" }, [_vm._v("Holiday+ Detail")]),
      _vm._v(" "),
      _c("div", { staticClass: "subtitle" }, [
        _vm._v("Manage your Holiday+ Entegration"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }